import React from 'react';
import { Helmet } from 'react-helmet';
import { reducePropsToState } from 'react-helmet/lib/HelmetUtils'
import TrackOnMount from './TrackOnMount';

const defaultTitle = 'Training App';
const titleTemplate = '%s – Training App';

// Compute the next Helmet title formatted using the titleTemplate. We do this
// to immediately track the page title without waiting for a re-render and a
// document.title update.
function computeNextHelmetTitle(title) {
  const helmetState = reducePropsToState([{
    title,
    defaultTitle,
    titleTemplate,
  }]);

  return helmetState.title;
}

export default function PageTitle({
  title,
  withTracking = false,
  trackingOptions = {},
}) {
  return (
    <React.Fragment>
      <Helmet
        defaultTitle={defaultTitle}
        titleTemplate={titleTemplate}>
        <title>{title}</title>
      </Helmet>

      {withTracking && (
        <TrackOnMount options={{
          page_title: computeNextHelmetTitle(title),
          ...trackingOptions,
        }} />
      )}
    </React.Fragment>
  );
}
